<template>
  <div>
    <div class="secTie">
      <van-row gutter="2">
        <van-col span="2">排名</van-col>
        <van-col span="14">本店TOP SKUs</van-col>
        <van-col span="4">流量</van-col>
        <!-- <van-col span="3">转化</van-col>
        <van-col span="3">客单</van-col>
        <van-col span="4">预售定金</van-col> -->
        <van-col span="4">支付金额</van-col>
      </van-row>
    </div>
    <div class="box" v-for="(item, index) in JnJList" :key="index">
      <div class="mainTie">
        <van-row gutter="2">
          <van-col span="2"><b class="el-icon-star-on" style="color: rgb(250, 186, 53); font-size: 20px"></b>
          </van-col>
          <van-col
            span="14"
            style="overflow: hidden; line-height: 20px; padding-top: 8px"
            ><b>{{ item.goodsInfo }}</b>
          </van-col>
          <van-col span="4"
            ><b>{{ item.visitorsEn }}</b>
          </van-col>
          <van-col span="4"
            ><b>{{ item.transactionAmountEn }}</b>
          </van-col>
        </van-row>
        <p
          class="info"
          @click="showTableMain(item.goodsInfo, item.goodsId, $event)"
        >
          查看详情 <i class="el-icon-caret-bottom"></i>
        </p>
      </div>
      <div class="table" style="display: none">
        <!-- <div class="tableHead" style="border-bottom: 1px solid black">
          <van-row gutter="5">
            <van-col span="4"><span class="opa">1</span></van-col>
            <van-col span="5">流量</van-col>
            <van-col span="5">转化</van-col>
            <van-col span="5">客单</van-col>
            <van-col span="5">支付金额</van-col>
          </van-row>
        </div>
        <van-row
          gutter="5"
          class="tableMain"
          v-for="(item, index) in DetailListMain"
          :key="index"
        >
          <van-col span="4">{{ item.trafficType }}</van-col>
          <van-col span="5">{{ item.visitorsEn }}</van-col>
          <van-col span="5">{{ item.paymentRate }}</van-col>
          <van-col span="5">{{ item.price }}</van-col>
          <van-col span="5">{{ item.transactionAmountEn }}</van-col>
        </van-row> -->
        <div class="echartsBox">
          <div class="echartsButton">
            <el-button
              size="mini"
              :class="{ active: clickMainType == '流量' }"
              @click="changeType($event, item.goodsInfo)"
              >流量</el-button
            >
            <!-- <el-button size="mini" @click="changeType($event, item.getshop)"
              >预售定金</el-button
            > -->
            <el-button size="mini" @click="changeType($event, item.goodsInfo)"
              >支付金额</el-button
            >
          </div>
          <div :id="item.getshop" class="echarts"></div>
        </div>
      </div>
    </div>
    <div class="secTie">
      <van-row gutter="2">
        <van-col span="2">排名</van-col>
        <van-col span="14">竞品名称</van-col>
        <van-col span="4">流量</van-col>
        <!-- <van-col span="3">转化</van-col>
        <van-col span="3">客单</van-col>
        <van-col span="4">预售定金</van-col> -->
        <van-col span="4">支付金额</van-col>
      </van-row>
    </div>
    <div class="loopCon">
      <van-swipe @change="onChange" indicator-color="#B6B6DF">
        <van-swipe-item v-for="item in shopLength" :key="item">
          <div class="box" v-for="(item2, index) in shopList" :key="index">
            <div class="mainTie">
              <van-row gutter="5">
                <van-col span="2">{{
                  index + pageIndex * pageSize - 4
                }}</van-col>
                <van-col
                  span="14"
                  style="overflow: hidden; line-height: 20px; padding-top: 8px"
                  >{{ item2.goodsInfo }}</van-col
                >
                <van-col span="4">{{ item2.visitorsEn }}</van-col>
                <!-- <van-col span="3">{{ item2.paymentRate }}</van-col>
                <van-col span="3">{{ item2.price }}</van-col>
                <van-col span="4">{{ item2.payPriceEn }}</van-col> -->
                <van-col span="4">{{ item2.transactionAmountEn }}</van-col>
              </van-row>
              <p
                class="info"
                @click="showTable(item2.goodsInfo, item2.goodsId, $event)"
              >
                查看详情 <i class="el-icon-caret-bottom"></i>
              </p>
            </div>
            <div class="table" style="display: none">
              <!-- <div class="tableHead" style="border-bottom: 1px solid black">
                <van-row gutter="5">
                  <van-col span="4"><span class="opa">1</span></van-col>
                  <van-col span="5">流量</van-col>
                  <van-col span="5">转化</van-col>
                  <van-col span="5">客单</van-col>
                  <van-col span="5">支付金额</van-col>
                </van-row>
              </div>
              <div
                v-for="(item, index) in DetailList"
                :key="index"
                class="tableMain"
              >
                <van-row
                  gutter="5"
                  :class="{ litTetx: item.trafficType == '直播' }"
                >
                  <van-col
                    span="4"
                    :style="{
                      'padding-left': item.trafficType == '直播' ? '30px' : '0',
                    }"
                    >{{ item.trafficType }}</van-col
                  >
                  <van-col span="5">{{ item.visitorsEn }}</van-col>
                  <van-col span="5">{{ item.paymentRate }}</van-col>
                  <van-col span="5">{{ item.price }}</van-col>
                  <van-col span="5">{{ item.transactionAmountEn }}</van-col>
                </van-row>
              </div> -->

              <div class="echartsBox">
                <div class="echartsButton">
                  <el-button
                    size="mini"
                    :class="{ active: clickType == '流量' }"
                    @click="change($event, item2.goodsInfo)"
                    >流量</el-button
                  >
                  <!-- <el-button size="mini" @click="change($event, item2.shopInfo)"
                    >预售定金</el-button
                  > -->
                  <el-button
                    size="mini"
                    @click="change($event, item2.goodsInfo)"
                    >支付金额</el-button
                  >
                </div>
                <div class="echarts"></div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import { Toast } from "vant";

import uv from "../../assets/jpg/uv.svg";
import pos from "../../assets/jpg/pos.svg";
export default {
  data() {
    return {
      bindCharts: "",
      JnJDataMain: [],
      storeData: [],
      JnJData: [],
      MyxAxis: [],
      isShow: false,
      brand: "",
      shopList: [],
      JnJList: [],
      shopLength: 10,
      pageIndex: 1,
      pageSize: 5,
      DetailList: [],
      DetailListMain: [],
      clickType: "流量",
      clickMainType: "流量",
      visitorsListMain: [],
      paymentPriceListMain: [],
      transactionAmountListMain: [],
      storeVisitorsList: [],
      storePaymentPriceList: [],
      storeTransactionAmountList: [],
      JnJVisitorsList: [],
      JnJPaymentPriceList: [],
      JnJTransactionAmountList: [],
    };
  },
  methods: {
    changeType(e, bindObj) {
      this.clickMainType = $(e.currentTarget).text();
      if (this.clickMainType == "流量") {
        this.JnJDataMain = this.visitorsListMain;
      } else {
        this.JnJDataMain = this.transactionAmountListMain;
      }
      this.drawLineMain(bindObj);
    },
    change(e, bindObj) {
      this.clickType = $(e.currentTarget).text();
      if (this.clickType == "流量") {
        this.storeData = this.storeVisitorsList;
      } else {
        this.storeData = this.storeTransactionAmountList;
      }
      this.drawLine(bindObj);
    },
    getShopsChartMain(bindObj) {
      this.$addr
        .post(
          "/Sales/getSkuChart",
          qs.stringify({
            skuName: bindObj,
            competeType: 0,
          })
        )
        .then((res) => {
          this.JnJDataMain = [];
          this.MyxAxis = [];
          this.visitorsListMain = [];
          this.paymentPriceListMain = [];
          this.transactionAmountListMain = [];
          res.data.data.map((item, index) => {
            this.JnJDataMain.push(item.visitors);
            this.visitorsListMain.push(item.visitors);
            this.paymentPriceListMain.push(item.payprice);
            this.transactionAmountListMain.push(item.transactionAmount);
            this.MyxAxis.push(item.date);
            this.MyxAxis = [...new Set(this.MyxAxis)];
          });
          this.drawLineMain(bindObj);
        });
    },
    getShopsChart(bindObj) {
      this.$addr
        .post(
          "/Sales/getSkuChart",
          qs.stringify({
            skuName: bindObj,
            competeType: 1,
            brand: this.brand,
          })
        )
        .then((res) => {
          var jnj = [];
          var store = [];
          res.data.data.map((item, index) => {
            if (item.competeType == 1) {
              store.push(item);
            } else {
              jnj.push(item);
            }
          });
          this.storeData = [];
          this.storeVisitorsList = [];
          // this.storePaymentPriceList = [];
          this.storeTransactionAmountList = [];
          res.data.data.map((item, index) => {
            this.storeData.push(item.visitors);
            this.storeVisitorsList.push(item.visitors);
            // this.storePaymentPriceList.push(item.payprice);
            this.storeTransactionAmountList.push(item.transactionAmount);
            this.MyxAxis.push(item.date);
            this.MyxAxis = [...new Set(this.MyxAxis)];
          });

          this.drawLine(bindObj);
        });
    },
    drawLineMain(bindObj) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(bindObj));
      // 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          height: 260,
          backgroundColor: " rgba(204, 69, 69,0.8);",
          padding: [5, 15, 5, 15], //边距
          borderColor: "#DDDDDF", //边框颜色
          borderWidth: 1, //边框线宽度
          textStyle: {
            //文字样式
            fontFamily: "PingFangSC-Regular",
            fontSize: "12px",
            color: " #FFFFFF",
          },
        },
        legend: {
          top: "3.5%",
          right: "5%",
          itemWidth: 13,
          itemHeight: 13,
          icon: "circle",
          data: [
            {
              name: "J&J",
            },
          ],
          textStyle: {
            color: "#626262",
            fontSize: 10,
            letterSpacing: 0,
            fontFamily: "PingFangSC-Regular",
          },
        },
        grid: [
          {
            show: false,
          },
        ],
        // dataZoom: [
        //   {
        //     xAxisIndex: 0, //这里是从X轴的0刻度开始
        //     show: true, //是否显示滑动条，不影响使用
        //     type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
        //     startValue: 15, // 从头开始。
        //     endValue: 30, // 一次性展示6个。
        //     height: 20,
        //     handleSize: 0,
        //     backgroundColor: "rgba(209,87,87,.7)",
        //     top: "90%",
        //   },
        // ],
        xAxis: {
          show: true,
          type: "category",
          boundaryGap: true,
          splitLine: { show: false },
          data: this.MyxAxis,
          axisLabel: {
            interval: 0,
            rotate: 40,
            show: true,
            textStyle: {
              fontFamily: "STYuanti-SC-Light",
              fontSize: 10,
              color: "#292929",
              letterSpacing: 0,
              textAlign: "center",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
        },
        yAxis: [
          {
            name: ["J&J"],
            show: true,
            type: "value",
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              formatter: function (value, index) {
                if (value < 1000) {
                  return value;
                } else if (value >= 1000 && value < 1000000) {
                  return value / 1000 + "K";
                } else if (value >= 1000000 && value < 1000000000) {
                  return value / 1000000 + "M";
                } else if (value >= 1000000000 && value < 1000000000000) {
                  return value / 1000000000 + "B";
                }
              },
              interval: 0,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center",
              },
            },
            min: 0,
            boundaryGap: ["0.43", "0.12"],
            axisTick: {},
          },
        ],
        series: [
          {
            name: "J&J",
            type: "line",
            data: this.JnJDataMain,
            smooth: true,
            yAxisIndex: 0,
            symbolSize: 6,
            itemStyle: {
              normal: {
                color: "red", //折线颜色
              },
            },
          },
        ],
      });
    },
    drawLine(bindObj) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(bindObj));
      // 绘制图表
      myChart.setOption(
        {
          tooltip: {
            trigger: "axis",
            height: 260,
            backgroundColor: " rgba(204, 69, 69,0.8);",
            padding: [5, 15, 5, 15], //边距
            borderColor: "#DDDDDF", //边框颜色
            borderWidth: 1, //边框线宽度
            textStyle: {
              //文字样式
              fontFamily: "PingFangSC-Regular",
              fontSize: "12px",
              color: " #FFFFFF",
            },
          },
          legend: {
            show: true,
            top: "3.5%",
            right: "3.5%",
            itemWidth: 10,
            itemHeight: 10,
            icon: "circle",
            data: [
              {
                name: "竞店",
              },
            ],
            textStyle: {
              color: "#626262",
              fontSize: 10,
              letterSpacing: 0,
              fontFamily: "PingFangSC-Regular",
            },
          },
          grid: [
            {
              show: false,
            },
          ],
          xAxis: {
            show: true,
            type: "category",
            boundaryGap: true,
            splitLine: { show: false },
            data: this.MyxAxis,
            axisLabel: {
              interval: 0,
              rotate: 40,
              show: true,
              textStyle: {
                fontFamily: "STYuanti-SC-Light",
                fontSize: 10,
                color: "#292929",
                letterSpacing: 0,
                textAlign: "center",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
          },
          yAxis: [
            {
              name: ["竞店"],
              show: true,
              type: "value",
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#ccc",
                },
              },
              axisLabel: {
                formatter: function (value, index) {
                  if (value < 1000) {
                    return value;
                  } else if (value >= 1000 && value < 1000000) {
                    return value / 1000 + "K";
                  } else if (value >= 1000000 && value < 1000000000) {
                    return value / 1000000 + "M";
                  } else if (value >= 1000000000 && value < 1000000000000) {
                    return value / 1000000000 + "B";
                  }
                },
                interval: 0,
                show: true,
                textStyle: {
                  fontFamily: "STYuanti-SC-Light",
                  fontSize: 10,
                  color: "#292929",
                  letterSpacing: 0,
                  textAlign: "center",
                },
              },
              min: 0,
              boundaryGap: ["0.43", "0.12"],
              axisTick: {},
            },
          ],
          series: [
            {
              name: "竞店",
              type: "line",
              smooth: true,
              data: this.storeData,
              yAxisIndex: 0,
              symbolSize: 6,
              itemStyle: {
                normal: {
                  color: "#472FC8", //折线颜色
                },
              },
            },
          ],
        },
        true
      );
    },
    onChange(index) {
      $(".table").css("display", "none");
      $(".echarts").removeAttr("id");
      this.pageIndex = index + 1;
      this.getShops();
    },
    showTableMain(bindObj, goodsId, e) {
      $(e.currentTarget).stop().parent().next(".table").slideToggle(500);
      $(e.currentTarget)
        .parent()
        .next(".table")
        .children(".echartsBox")
        .children(".echarts")
        .attr("id", bindObj);
      this.getShopsMainDetail(bindObj, goodsId);
      this.getShopsChartMain(bindObj);
    },
    showTable(bindObj, goodsId, e) {
      this.clickType = "流量";
      $(e.currentTarget)
        .parent()
        .next(".table")
        .children(".echartsBox")
        .children(".echarts")
        .attr("id", bindObj);
      $(e.currentTarget).stop().parent().next(".table").slideToggle(500);
      $(e.currentTarget)
        .parent()
        .parent()
        .siblings()
        .find(".table")
        .slideUp(300);
      this.getShopsDetail(bindObj, goodsId);
      this.getShopsChart(bindObj);
    },
    getShops() {
      this.$addr
        .post(
          "/Sales/getSku",
          qs.stringify({
            brand: this.brand,
            competeType: 1,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
          })
        )
        .then((res) => {
          if (res.data.total != 0 && res.data.total / 5 > this.shopLength) {
            this.shopLength;
          } else {
            this.shopLength = parseInt(res.data.total / 5);
          }
          this.shopList = [];
          this.shopList = res.data.data;
        });
    },
    getJnJ() {
      this.$addr
        .post(
          "/Sales/getSku",
          qs.stringify({ brand: this.brand, competeType: 0 })
        )
        .then((res) => {
          this.JnJList = [];
          this.JnJList = res.data.data;
        });
    },
    getShopsMainDetail(bindObj, goodsId) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$addr
        .post(
          "/Sales/getSkuDetail",
          qs.stringify({
            SkuName: bindObj,
            brand: this.brand,
            skuCode: goodsId,
          })
        )
        .then((res) => {
          this.DetailListMain = [];
          this.DetailListMain = res.data.data;
          Toast.clear();
        });
    },
    getShopsDetail(bindObj, goodsId) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$addr
        .post(
          "/Sales/getSkuDetail",
          qs.stringify({
            SkuName: bindObj,
            brand: this.brand,
            skuCode: goodsId,
          })
        )
        .then((res) => {
          this.DetailList = [];
          this.DetailList = res.data.data;
          Toast.clear();
        });
    },
  },
  props: ["brandName"],
  watch: {
    brandName: {
      handler(newValue, oldValue) {
        $(".table").slideUp(300);
        this.brand = newValue;
        this.getShops();
        this.getJnJ();
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.active {
  border-color: goldenrod;
  color: goldenrod;
}
/deep/ .el-button:active {
  border-color: goldenrod;
  color: goldenrod;
  background-color: #fff;
}
/deep/ .el-button:hover {
  border-color: goldenrod;
  color: goldenrod;
  background-color: #fff;
}
.litPad {
  padding-left: 10px;
}
.litTetx {
  /* padding: 5px 0 0 10px; */
  text-align: center;
  font-family: "PingFangSC-Regular";
  color: #8b8d96;
  position: relative;
}
.litTetx::before {
  position: absolute;
  left: 15px;
  top: -15px;
  content: "";
  width: 20px;
  height: 40px;
  background: url("../../assets/jpg/branch.png") no-repeat;

  background-size: 100%;
}
.opa {
  opacity: 0;
}
.mainTie {
  border: 1px solid lightgray;
  overflow: hidden;
  padding: 0 10px;
  margin: 10px auto;
  height: 80px;
  line-height: 50px;
  background: rgb(255, 255, 255);

  border-radius: 20px;
  position: relative;
  text-align: center;
}
.secTie {
  text-align: center;
  padding: 0 10px;
  margin: 10px auto;
  background: #e8e8f6;
  color: #343434;
}
.tableHead {
  padding-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.tableMain {
  font-family: "ArialMT";
  color: #002f00;
  margin: 10px 0;
  text-align: center;
  line-height: 20px;
}

.echartsBox {
  position: relative;
}
.echartsButton {
  z-index: 9;
  position: absolute;
  width: 100px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  left: 15%;
  top: 5%;
}
.echarts {
  min-width: 100% !important;
  height: 260px;
}
/deep/ .van-swipe {
  padding-bottom: 20px;
}
/deep/ .van-swipe__indicators {
  bottom: 0px;
  left: 30%;
}
/deep/ .van-swipe__indicators::before{
  font-weight: bold;
  content: '<';
  margin-right: 10px;
  font-family: "PingFangSC-Regular";
  color: #8b8d96;
  font-size: 16px;
      line-height: 11px;
}
/deep/ .van-swipe__indicators::after{
  font-weight: bold;
  content: '>';
  margin-left: 10px;
  font-family: "PingFangSC-Regular";
  color: #8b8d96;
  font-size: 16px;
      line-height: 11px;
}
/deep/ .van-swipe__indicator {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background-color: rgb(227, 227, 244);
}
/deep/ .van-swipe__indicator--actives {
  width: 30px;
}
.info {
  position: absolute;
  right: 5px;
  bottom: 0px;
  color: goldenrod;
}
</style>


// WEBPACK FOOTER //
// src/components/Market/product.vue